import { createVueDaumPostcode } from "./createVueDaumPostcode";

const VueDaumPostcode = createVueDaumPostcode();

export default VueDaumPostcode;
